//
import { redux_store } from "../../../store";
import { API } from "../../api";
async function delete_address(request) {
    // console.log("delete_address -> request", request);
    const state = redux_store.getState();
    const userState = state.userState;
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/delete/address`, //
        content: request,
        authorization: userState.user.token,
    });
}
export { 
// IDeleteAddressRequest,
delete_address, };
